import React, { Fragment, useEffect, useRef, useState } from "react";
import ClientModalMesures from "./EB1/EB1_3";
import ClientModalEntite from "./EB1/EB1_1";
import {
  addReponseAccepation,
  addReponseQuestion,
  getListeReponseMission,
  updateReponseQuestion,
} from "../../../../../data/exercice";
import FileUploadQuestionnaire from "./EB1/FileUploadQuestionnaire";
import swal from "sweetalert";
import { succesMessage } from "../../../../../helpers/AssetsHelpers";
import { Button, notification, Space, Steps, Tooltip } from "antd";
import { getListeQuestion } from "../../../../../data/params/question";
import { ajouterUserIdentification } from "../../../../../data/rateau";
import ReactToPrint from "react-to-print";
import docx from "html-docx-js/dist/html-docx";
import fileSaver from "file-saver";
import { PrintHeader } from "../../../../layout/tools/PrintHeader";
import {
  faBriefcase,
  faCheckDouble,
  faFileCircleCheck,
  faFileCircleQuestion,
  faFile,
  faFileWord,
  faIdCard,
  faListCheck,
  faLock,
  faPrint,
  faUserTag,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StepBody, StepHeader } from "../../../../common/Step.components";
import { Spinner } from "@chakra-ui/react";
import { appTheme } from "../../../../../config/theme";
import ClientModalAffectation from "./EB1/EB1_4";
import PageChildLabel from "../../../../common/PageLabel/PageChildLabel";
import { AcceptationPrint } from "./EB1/AcceptationPrint";
import UserCycleIdentification from "../../UserCycleIdentification";
import { useLocation, useNavigate } from "react-router-dom";

const { Step } = Steps;

const AcceptationMission = ({ mission, client, code, modalId, prev }) => {
  const navigate = useNavigate();
  // const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mesure_sauve, setMesureSauve] = useState(mission?.mesure_sauve);
  const [selectedElementsListEntity, setSelectedElementsListEntity] = useState(
    []
  );
  const [selectedElementsListAudit, setSelectedElementsListAudit] = useState(
    []
  );
  const [isFileAdd, setIsFileAdd] = useState(false);
  const [questionsEntity, setQuestionsEntity] = useState([]);
  const [questionsAuditeur, setQuestionsAuditeur] = useState([]);
  const [listQuestionAdd, setListQuestionAdd] = useState(false);
  const [codeSommaire] = useState(code || "EB1");
  const [tache_id, setTache_id] = useState(null);
  const [user_id, setUser_id] = useState(null);
  const [date, setDate] = useState("");
  const [heureEntree, setHeureEntree] = useState("");
  const [intervention_id, setIntervention_id] = useState(null);
  // const [isModalOpen, setIsModalOpen] = useState(true);
  // const [identLoading, setIdentLoading] = useState(false);
  const [acceptValid] = useState(modalId === 2 || false);
  const [affectValid, setAffectValid] = useState(false);
  const [observation_generale, setObservation_generale] = useState("");
  const [associe_responsable, setAssocieResponsable] = useState("");
  const [second_associer, setSecondAssocier] = useState("");
  const [etat, setEtat] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isTaskSave, setIsTaskSave] = useState([]);
  const [isToggleOpen, setIsToggleOpen] = useState(false);
  const [auth, setAuth] = useState(false);
  // const [authId, setAuthId] = useState(null);
  const componentRef = useRef();
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = () => {
    api["warning"]({
      message: "Attention! Cycle verrouillé.",
      description: "Veuillez vous identifier !",
    });
  };

  useEffect(() => {
    setAffectValid(
      mission?.etat === 2 && mission && mission?.lettre_mission === 1
    );
    setIsFileAdd(mission?.fichier_question === 1);
    setAssocieResponsable(mission.associe_responsable);
    setSecondAssocier(mission.second_associer);
  }, [mission]);

  // ✅ Fonction améliorée pour l'exportation Word - Format Portrait optimisé
  const exportToWord = () => {
    try {
      const content = document.getElementById("print-content");

      if (!content) {
        notification.error({
          message: "Erreur d'exportation",
          description: "Le contenu à exporter n'est pas disponible",
        });
        return;
      }

      // ✅ Styles optimisés pour Word - Format Portrait avec occupation maximale
      const wordStyles = `
        <style>
          @page {
            size: A4 portrait;
            margin: 15mm 10mm 15mm 10mm;
          }
          
          body { 
            font-family: 'Times New Roman', serif !important;
            font-size: 11pt !important;
            line-height: 1.3 !important;
            color: #000 !important;
            background: white !important;
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
          }
          
          .print-content {
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          
          .header-print {
            text-align: center !important;
            margin-bottom: 20px !important;
            padding-bottom: 15px !important;
            border-bottom: 2px solid #000 !important;
          }
          
          .header-print h1 {
            font-size: 16pt !important;
            font-weight: bold !important;
            margin: 0 0 10px 0 !important;
            color: #000 !important;
          }
          
          .header-print div {
            font-size: 12pt !important;
            color: #666 !important;
            margin-top: 8px !important;
          }
          
          .section {
            margin-bottom: 15px !important;
            width: 100% !important;
          }
          
          table { 
            border-collapse: collapse !important; 
            width: 100% !important; 
            margin-bottom: 12px !important;
            table-layout: fixed !important;
          }
          
          th, td { 
            border: 1px solid #000 !important; 
            padding: 4px 6px !important; 
            text-align: left !important;
            font-size: 9pt !important;
            line-height: 1.2 !important;
            vertical-align: top !important;
            word-wrap: break-word !important;
          }
          
          th { 
            background-color: #f5f5f5 !important; 
            font-weight: bold !important;
            text-align: center !important;
          }
          
          /* Styles spécifiques pour les sections */
          .my-10 {
            margin: 10px 0 !important;
          }
          
          .fw-bolder {
            font-size: 13pt !important;
            font-weight: bold !important;
            text-align: center !important;
            margin: 15px 0 10px 0 !important;
            padding: 8px !important;
            background-color: #f5f5f5 !important;
            border: 1px solid #ccc !important;
          }
          
          .text-center {
            text-align: center !important;
          }
          
          .text-start {
            text-align: left !important;
          }
          
          /* Optimisation des largeurs de colonnes */
          .tablePerso th:first-child,
          .tablePerso td:first-child {
            width: 5% !important; /* Colonne N° */
          }
          
          .tablePerso th:nth-child(2),
          .tablePerso td:nth-child(2) {
            width: 60% !important; /* Colonne Question */
          }
          
          .tablePerso th:nth-child(3),
          .tablePerso td:nth-child(3) {
            width: 12% !important; /* Colonne Réponse */
            text-align: center !important;
          }
          
          .tablePerso th:nth-child(4),
          .tablePerso td:nth-child(4) {
            width: 23% !important; /* Colonne Commentaires */
          }
          
          /* Tableaux mesures de sauvegarde */
          .mesure-table th:first-child,
          .mesure-table td:first-child {
            width: 4% !important; /* N° */
          }
          
          .mesure-table th:nth-child(2),
          .mesure-table td:nth-child(2) {
            width: 35% !important; /* Critères */
          }
          
          .mesure-table th:nth-child(3),
          .mesure-table td:nth-child(3) {
            width: 8% !important; /* Réponse */
          }
          
          .mesure-table th:nth-child(4),
          .mesure-table td:nth-child(4) {
            width: 25% !important; /* Commentaire */
          }
          
          .mesure-table th:nth-child(5),
          .mesure-table td:nth-child(5) {
            width: 28% !important; /* Mesure sauvegarde */
          }
          
          /* Signatures */
          .signature-table th,
          .signature-table td {
            width: 50% !important;
            height: 80px !important;
            text-align: center !important;
            vertical-align: middle !important;
          }
          
          /* Suppression des éléments non nécessaires */
          .no-print, .btn, .d-none, .card, .px-0 {
            display: none !important;
          }
          
          /* Force l'affichage des tableaux */
          table {
            page-break-inside: auto !important;
          }
          
          tr {
            page-break-inside: avoid !important;
          }
          
          /* Ajustements pour les titres */
          h2.fw-bolder {
            page-break-after: avoid !important;
            font-size: 12pt !important;
            margin: 12px 0 8px 0 !important;
            padding: 6px !important;
          }
          
          /* Optimisation de l'espace */
          .mb-3, .mb-5 {
            margin-bottom: 8px !important;
          }
          
          .py-5 {
            padding: 6px 0 !important;
          }
          
          /* Styles pour observations générales */
          .observation-box {
            border: 1px solid #000 !important;
            padding: 8px !important;
            min-height: 50px !important;
            background-color: #fafafa !important;
            margin-top: 15px !important;
          }
        </style>
      `;

      // ✅ Template HTML optimisé pour Word Portrait
      const fullContent = `
        <!DOCTYPE html>
        <html xmlns:o="urn:schemas-microsoft-com:office:office" 
              xmlns:w="urn:schemas-microsoft-com:office:word" 
              xmlns="http://www.w3.org/TR/REC-html40">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Acceptation Mission ${codeSommaire} - ${
        mission?.numero || "N-A"
      }</title>
            <!--[if gte mso 9]>
            <xml>
              <w:WordDocument>
                <w:View>Print</w:View>
                <w:Zoom>100</w:Zoom>
                <w:DoNotPromptForConvert/>
                <w:DoNotShowInsertionsAndDeletions/>
                <w:TrackRevisions>false</w:TrackRevisions>
                <w:DoDisplayPageBoundaries>false</w:DoDisplayPageBoundaries>
              </w:WordDocument>
            </xml>
            <![endif]-->
            ${wordStyles}
          </head>
          <body>
            <div class="word-document">
              ${content.innerHTML
                .replace(/class="tablePerso"/g, 'class="tablePerso"')
                .replace(
                  /style="([^"]*border-collapse:[^"]*)/g,
                  'class="mesure-table" style="$1'
                )
                .replace(
                  /DÉCISION ET AFFECTATION DU DOSSIER/g,
                  '"DÉCISION ET AFFECTATION DU DOSSIER" class="signature-section"'
                )}
          </body>
        </html>
      `;

      // ✅ Génération du Blob pour Word
      const blob = new Blob([fullContent], {
        type: "application/msword",
      });

      // ✅ Nom de fichier avec horodatage
      const timestamp = new Date()
        .toLocaleDateString("fr-FR")
        .replace(/\//g, "-");
      const fileName = `Acceptation_Mission_${codeSommaire}_${
        mission?.numero || "N-A"
      }_${timestamp}.doc`;

      // ✅ Téléchargement du fichier avec file-saver
      fileSaver.saveAs(blob, fileName);

      // ✅ Fermeture du menu et notification
      setIsToggleOpen(false);

      /* notification.success({
        message: "Exportation réussie",
        description: `Le document Word "${fileName}" a été téléchargé avec succès`,
        duration: 4,
        placement: "topRight",
      }); */
    } catch (error) {
      console.error("Erreur lors de l'exportation Word:", error);

      setIsToggleOpen(false);

      notification.error({
        message: "Erreur d'exportation",
        description: `Impossible de générer le document Word : ${error.message}`,
        duration: 6,
        placement: "topRight",
      });
    }
  };

  // ✅ Styles améliorés pour l'impression PDF
  const pageStyle = `
    @media print {
      body { 
        font-family: 'Times New Roman', serif !important;
        font-size: 12pt !important;
        line-height: 1.4 !important;
        color: #000 !important;
        background: white !important;
        margin: 0 !important;
        padding: 20px !important;
      }
      
      .print-content {
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 0 !important;
        box-shadow: none !important;
        border: none !important;
      }
      
      .header-print {
        text-align: center !important;
        font-size: 16pt !important;
        font-weight: bold !important;
        margin-bottom: 25px !important;
        padding-bottom: 10px !important;
        border-bottom: 2px solid #000 !important;
      }
      
      .section {
        margin-bottom: 20px !important;
        page-break-inside: avoid !important;
      }
      
      .section-title {
        font-size: 14pt !important;
        font-weight: bold !important;
        margin-bottom: 15px !important;
        color: #000 !important;
        text-align: center !important;
        background-color: #f5f5f5 !important;
        padding: 10px !important;
        page-break-after: avoid !important;
      }
      
      table { 
        border-collapse: collapse !important; 
        width: 100% !important; 
        margin-bottom: 15px !important;
        page-break-inside: avoid !important;
      }
      
      th, td { 
        border: 1px solid #000 !important; 
        padding: 6px !important; 
        text-align: left !important;
        font-size: 10pt !important;
        line-height: 1.3 !important;
      }
      
      th { 
        background-color: #f5f5f5 !important; 
        font-weight: bold !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
      
      .no-print {
        display: none !important;
      }
      
      .page-break {
        page-break-before: always !important;
      }
    }
    
    @page {
      size: A4 portrait !important;
      margin: 20mm 15mm 25mm 15mm !important;
    }
  `;

  // ✅ Fonction pour fermer le menu au clic extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isToggleOpen && !event.target.closest("#export-menu-container")) {
        setIsToggleOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isToggleOpen]);

  useEffect(() => {
    fetchQuestionnaire();
  }, []);

  const fetchQuestionnaire = () => {
    getListeQuestion()
      .then((res) => {
        const entities = res.result.filter(
          (item) => item.Bog_GroupeQuestion.critereGroupe === "ENTITE"
        );
        const auditeurs = res.result.filter(
          (item) => item.Bog_GroupeQuestion.critereGroupe === "AUDITEUR"
        );
        if (entities.length > 0) {
          const libelleGroup = [
            ...new Set(entities.map((item) => item.Bog_GroupeQuestion.libelle)),
          ];
          const tab = libelleGroup.map((libelle) => ({
            libelleGroupe: libelle,
            questions: entities.filter(
              (item) => item.Bog_GroupeQuestion.libelle === libelle
            ),
          }));

          setQuestionsEntity(tab);
        }
        if (auditeurs) {
          const libelleGroup = [
            ...new Set(
              auditeurs.map((item) => item.Bog_GroupeQuestion.libelle)
            ),
          ];
          const tab = libelleGroup.map((libelle) => ({
            libelleGroupe: libelle,
            questions: auditeurs.filter(
              (item) => item.Bog_GroupeQuestion.libelle === libelle
            ),
          }));

          setQuestionsAuditeur(tab);
        }
      })
      .catch((error) => {
        console.error("Error fetching questionnaire:", error);
      });
  };

  useEffect(() => {
    getListeReponseMission(mission.id).then((res) => {
      if (res.length > 0) {
        setListQuestionAdd(true);
      }

      let mainArraySetEntity = [];
      let mainArraySetAuditeur = [];

      const array2 = [];
      const array1 = [];
      if (questionsEntity.length > 0) {
        questionsEntity.forEach((quest) => {
          mainArraySetEntity = new Set(
            quest.questions.map((question) => question.id)
          );
          const arrayEntity = res.filter((element) =>
            mainArraySetEntity.has(element.question_id)
          );
          if (arrayEntity.length > 0) {
            arrayEntity.forEach((item) => {
              const element = {
                question_id: item.question_id,
                libelle: item.libelle,
                response: item.response,
                isChecked: item.response === "POSITIF",
                defaultResponse: item.reponse_defaut === "POSITIF",
                mesure_sauve: item.mesure_sauve,
                motifRequired: false,
                mesureRequired: false,
                motif: item.motif,
              };
              array1.push(element);
            });
          }
        });
        setSelectedElementsListEntity(array1);
        // setIsModified(array1?.length > 0)
      }

      if (questionsAuditeur.length > 0) {
        questionsAuditeur.forEach((quest) => {
          mainArraySetAuditeur = new Set(
            quest.questions.map((question) => question.id)
          );
          const arrayAuditeur = res.filter((element) =>
            mainArraySetAuditeur.has(element.question_id)
          );
          if (arrayAuditeur.length > 0) {
            arrayAuditeur.forEach((item) => {
              const element = {
                question_id: item.question_id,
                libelle: item.libelle,
                response: item.response,
                isChecked: item.response === "POSITIF",
                defaultResponse: item.reponse_defaut === "POSITIF",
                motifRequired: false,
                mesure_sauve: item.mesure_sauve,
                mesureRequired: false,
                motif: item.motif,
              };
              array2.push(element);
            });
          }
        });
        setSelectedElementsListAudit(array2);
        // setIsModified(array2?.length > 0)
      }
    });
  }, [mission, questionsEntity, questionsAuditeur]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (auth) {
        e.preventDefault();
        e.returnValue = ""; // required for chrome
        return true; // Return a truthy value
      }
      return null; // Allow navigation if no conditions met
    };

    // const handleBrowseAway = (e) => {
    //     e.preventDefault();
    //     return authId !== null;
    // };

    window.addEventListener("beforeunload", handleBeforeUnload);
    // window.addEventListener('popstate', handleBrowseAway);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      // window.removeEventListener('popstate', handleBrowseAway);
    };
  }, [auth, navigate]);

  // useEffect(() => {
  //     if(authId !== null){
  //         const unblock = navigate((newLocation, { action }) => {
  //             if (authId !== null && action === "POP") {
  //                 const confirmLeave = window.confirm(
  //                     "Vous avez des modifications non sauvegardées, voulez-vous vraiment quitter cette page ?"
  //                 );
  //                 if (!confirmLeave) {
  //                     return false;
  //                 }
  //             }
  //         });
  //
  //         return () => unblock;
  //     }
  // }, [authId, navigate]);

  const handleNextStep = (e) => {
    e.preventDefault();
    if (!auth) {
      openNotificationWithIcon();
      return setActiveStep(0);
    } else if (activeStep > 1 && !isFileAdd) {
      setActiveStep(1);
    } else {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevStep = (e) => {
    e.preventDefault();
    setActiveStep((prevStep) => prevStep - 1);
  };

  const isLastStep = () => {
    return activeStep === formSteps.length - 1;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const selectedItems = [
      ...selectedElementsListAudit,
      ...selectedElementsListEntity,
    ];

    const require = selectedItems.some(
      (item) => item.motifRequired || item.mesureRequired
    );
    if (require) {
      notification.warning({
        message: "Tous les champs obligatoires doivent être renseignés.",
      });
      setLoading(false);
      return;
    }

    const questionnaires = selectedItems.map((item) => ({
      question_id: item.question_id,
      reponse: item.isChecked ? "POSITIF" : "NEGATIF",
      motif: item.motif,
      mesure_sauve: item.mesure_sauve,
    }));

    const data = {
      intervention_id,
      date,
      heureEntree,
      tache_id,
      user_id,
      codeSommaire,
      questionnaires: questionnaires,
      exercice_id: mission.id,
      mesure_sauve: mesure_sauve,
      client_id: client.id,
    };

    const { status, message } =
      listQuestionAdd === true
        ? await updateReponseQuestion(data)
        : await addReponseQuestion(data);
    if (status === "success") {
      setLoading(false);
      setMesureSauve("");
      setSelectedElementsListAudit([]);
      setSelectedElementsListEntity([]);
      await swal(succesMessage, "", "success");
      if (activeStep > 3) {
        prev();
        window.location.reload();
      }
    } else {
      setLoading(false);
      await swal(message, "", "error");
    }
  };

  // const handleValidate = async (value) => {
  //     // setChargement(true)
  //     const data = {
  //         authId,
  //         intervention_id: value.intervention_id,
  //         tache_id: value.tache_id,
  //         codeSommaire,
  //         exercice_id: mission.id,
  //     };
  //
  //     const {status, message} = await ajouterUserIdentification(data);
  //     if (status === 'success') {
  //         await swal(succesMessage, '', 'success')
  //         setAuthId(null);
  //         prev();
  //     } else {
  //         // setChargement(false)
  //         await swal(message, '', 'error')
  //     }
  // }

  const handleAffectSubmit = async () => {
    setLoading(true);

    const data = {
      intervention_id,
      date,
      heureEntree,
      tache_id,
      user_id,
      codeSommaire,
      etat: etat,
      exercice_id: mission.id,
      client_id: client.id,
      associe_responsable,
      second_associer,
      motifs: selectedIds,
      observation_generale,
    };

    const { status, message } = await addReponseAccepation(data);
    if (status === "success") {
      setLoading(false);
      setSecondAssocier("");
      setAssocieResponsable("");
      await swal(succesMessage, "", "success");
      setAuth(false);
      if (activeStep > 4) {
        prev();
      }
      setIsTaskSave((prevState) =>
        (prevState ?? []).map((item) => item.activeTab)
      );
    } else {
      setLoading(false);
      await swal(message, "", "error");
    }
  };

  const formSteps = [
    {
      code: "ID",
      title: "IDENTIFICATIONS",
      icon: faIdCard,
      content: (
        <UserCycleIdentification
          setDate={setDate}
          dateDebut={date}
          setTache_id={setTache_id}
          setIntervention_id={setIntervention_id}
          setHeureEntree={setHeureEntree}
          setUser_id={setUser_id}
          mission={mission}
          prev={prev}
          loading={loading}
          codeSommaire={codeSommaire}
          setIsAuthorized={setAuth}
          isAuthorized={auth}
          setActiveStep={setActiveStep}
        />
      ),
    },
    {
      code: "EB1.0",
      title: "QUESTIONNAIRES MANUSCRIT",
      icon: faFileCircleQuestion,
      content: (
        <FileUploadQuestionnaire
          setIsFileAdd={setIsFileAdd}
          isFileAdd={isFileAdd}
          exercice={mission}
          client={client}
          codeSommaire={codeSommaire}
        />
      ),
    },
    {
      code: "EB1.1",
      title: "CRITERES RELATIF A L'ENTITÉ",
      icon: faBriefcase,
      content: (
        <ClientModalEntite
          loading={loading}
          selectedElementsList={selectedElementsListEntity}
          setSelectedElementsList={setSelectedElementsListEntity}
          questions={questionsEntity}
          client={client}
          mission={mission}
          codeSommaire={codeSommaire}
          acceptValid={acceptValid}
          title="EB1. 1: Acceptation Mission - Critères relatifs à l’Entité"
        />
      ),
    },
    {
      code: "EB1.2",
      title: "CRITERES RELATIF A L'AUDITEUR",
      icon: faUserTag,
      content: (
        <ClientModalEntite
          selectedElementsList={selectedElementsListAudit}
          setSelectedElementsList={setSelectedElementsListAudit}
          questions={questionsAuditeur}
          client={client}
          mission={mission}
          codeSommaire={codeSommaire}
          acceptValid={acceptValid}
          title="EB1. 2: Acceptation Mission - Critères relatifs à l’Auditeur"
        />
      ),
    },
    {
      code: "EB1.3",
      title: "MESURES DE SAUVEGARDE",
      icon: faListCheck,
      content: (
        <ClientModalMesures
          acceptValid={acceptValid}
          mission={mission}
          selectedElementsListAudit={selectedElementsListAudit}
          selectedElementsListEntity={selectedElementsListEntity}
          setSelectedElementsListAudit={setSelectedElementsListAudit}
          setSelectedElementsListEntity={setSelectedElementsListEntity}
        />
      ),
    },
    modalId === 2 && {
      code: "EB1.4",
      title: "DECISION ET AFFECTATION DU DOSSIER",
      icon: faFileCircleCheck,
      content: (
        <ClientModalAffectation
          mission={mission}
          setObservation_generale={setObservation_generale}
          observation_generale={observation_generale}
          second_associer={second_associer}
          setSecondAssocier={setSecondAssocier}
          setAssocieResponsable={setAssocieResponsable}
          associe_responsable={associe_responsable}
          setEtat={setEtat}
          affectValid={affectValid}
          setSelectedIds={setSelectedIds}
          selectedIds={selectedIds}
        />
      ),
    },
  ];

  const toggleMenu = (e) => {
    e.preventDefault();
    setIsToggleOpen(!isToggleOpen);
  };

  return (
    <>
      {contextHolder}
      <Fragment>
        <div className="d-flex justify-content-between pb-5">
          <PageChildLabel label={"EB1 - Acceptation de la mission"} />
          <div className="d-flex justify-content-between">
            <div className="d-flex me-15 mb-4">
              <Space>
                <div className="d-flex ms-5" id="export-menu-container">
                  <Tooltip title="Exporter le cycle">
                    <div className="d-flex flex-column align-items-center position-relative">
                      <button
                        className="btn btn-sm btn-flex btn-secondary fw-bold fs-7"
                        onClick={toggleMenu}
                      >
                        <FontAwesomeIcon icon={faPrint} className="me-3" />
                        Exporter
                      </button>

                      {/* ✅ Menu d'export amélioré */}
                      {isToggleOpen && (
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-option menu-column menu-rounded menu-gray-600 menu-state-bg-primary fw-bold fs-7 w-150px py-4 show"
                          style={{
                            position: "absolute",
                            right: "-90px",
                            zIndex: 1050,
                            backgroundColor: "white",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                            border: "1px solid #e4e6ef",
                            borderRadius: "6px",
                          }}
                        >
                          {/* ✅ Export PDF */}
                          <div className="menu-item px-3 py-2 bg-hover-primary text-hover-white rounded-2">
                            <ReactToPrint
                              trigger={() => (
                                <button
                                  className="fw-bold fs-7 text-hover-white w-100 text-start d-flex align-items-center"
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    padding: "4px 0",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faFilePdf}
                                    style={{
                                      fontSize: "16px",
                                      color: "#dc3545",
                                    }}
                                    className="me-3"
                                  />
                                  PDF
                                </button>
                              )}
                              content={() => componentRef.current}
                              documentTitle={`Acceptation_Mission_${codeSommaire}_${
                                mission?.numero || "N-A"
                              }`}
                              pageStyle={pageStyle}
                              onBeforeGetContent={() => {
                                return new Promise((resolve) => {
                                  setTimeout(resolve, 300);
                                });
                              }}
                              onAfterPrint={() => {
                                setIsToggleOpen(false);
                                /* notification.success({
                                  message: "Export PDF réussi",
                                  description: "Le document PDF a été généré",
                                }); */
                              }}
                              onPrintError={(errorLocation, error) => {
                                notification.error({
                                  message: "Erreur d'export PDF",
                                  description: "Impossible de générer le PDF",
                                });
                                setIsToggleOpen(false);
                              }}
                            />
                          </div>

                          {/* ✅ Export Word */}
                          <div className="menu-item px-3 py-2 bg-hover-primary text-hover-white rounded-2">
                            <button
                              className="fw-bold fs-7 text-hover-white w-100 text-start d-flex align-items-center"
                              style={{
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                padding: "4px 0",
                              }}
                              onClick={exportToWord}
                            >
                              <FontAwesomeIcon
                                icon={faFileWord}
                                style={{ fontSize: "16px", color: "#2b5797" }}
                                className="me-3"
                              />
                              WORD
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </Tooltip>
                </div>
              </Space>
            </div>

            <div className="d-flex ms-5">
              <div>
                <Tooltip title="Quitter le cycle" color="red">
                  <button
                    className="btn btn-sm btn-danger me-3"
                    onClick={() => prev()}
                  >
                    Retour
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-5">
          <StepHeader>
            <Steps
              current={activeStep}
              size="small"
              responsive={true}
              style={{ color: "green" }}
            >
              {formSteps.map((item, index) => (
                <Step
                  className="app-menu-option"
                  key={item.code}
                  title={
                    <>
                      <div className="d-flex align-center">
                        <span className="app-menu-option-title me-3">{`${
                          item.code || ""
                        }`}</span>
                        {!auth && index > 0 && (
                          <Tooltip
                            title="Cycle verrouillé. Veuillez vous identifier"
                            color="red"
                          >
                            <div>
                              <FontAwesomeIcon
                                icon={faLock}
                                style={{ color: "red", fontSize: "12px" }}
                              />
                            </div>
                          </Tooltip>
                        )}
                      </div>
                    </>
                  }
                  // description={item.title}
                  icon={<FontAwesomeIcon icon={item?.icon || faCheckDouble} />}
                  onClick={() => {
                    if (!auth) {
                      openNotificationWithIcon();
                      return setActiveStep(0);
                    } else if (index > 1 && !isFileAdd) {
                      setActiveStep(1);
                    } else {
                      setActiveStep(index);
                    }
                  }}
                />
              ))}
            </Steps>
          </StepHeader>
        </div>
        <StepBody>{formSteps[activeStep].content}</StepBody>
        <br />
        <div style={{ textAlign: "center" }}>
          {activeStep >= 1 && (
            <Button
              size="large"
              onClick={handlePrevStep}
              style={{ marginRight: "20px" }}
            >
              Précédent
            </Button>
          )}
          {!isLastStep() && (
            <Button
              size="large"
              onClick={handleNextStep}
              style={{
                marginRight: "20px",
                backgroundColor: appTheme.colors.primary_blue,
                color: "white",
              }}
            >
              Suivant
            </Button>
          )}
          {activeStep > 1 &&
            (loading ? (
              <Spinner ml={"10px"} />
            ) : modalId === 2 ? (
              (mission.isCloture !== 1 ||
                mission.isClotureProvisoire !== 1 ||
                !affectValid) && (
                <Button
                  size="large"
                  type="primary"
                  onClick={handleAffectSubmit}
                  style={{ marginRight: "20px" }}
                >
                  Enregistrer
                </Button>
              )
            ) : (
              (mission.isCloture !== 1 ||
                mission.isClotureProvisoire !== 1 ||
                !affectValid) && (
                <Button
                  size="large"
                  type="primary"
                  onClick={handleSubmit}
                  style={{ marginRight: "20px" }}
                >
                  Enregistrer
                </Button>
              )
            ))}
          <Button size="large" danger onClick={() => prev()}>
            Annuler
          </Button>
        </div>
        <br />
        <div className="d-none">
          <div ref={componentRef} className="print-content" id="print-content">
            <div>
              {/* ✅ En-tête amélioré */}
              <div className="header-print">
                <div style={{ textAlign: "center", marginBottom: "20px" }}>
                  <h1
                    style={{
                      margin: 0,
                      fontSize: "16pt",
                      fontWeight: "bold",
                    }}
                  >
                    TRAITEMENT ACCEPTATION DE LA MISSION
                  </h1>
                  <div
                    style={{
                      fontSize: "12pt",
                      marginTop: "10px",
                      color: "#666",
                    }}
                  >
                    Code Sommaire: {codeSommaire} | Mission:{" "}
                    {mission?.mission + " - " + mission?.annee || "N/A"}
                  </div>
                </div>
              </div>

              {/* ✅ Informations générales */}
              <div className="section">
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                  }}
                >
                  <tbody>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #000",
                          padding: "8px",
                          backgroundColor: "#f5f5f5",
                          width: "30%",
                        }}
                      >
                        Client
                      </th>
                      <td style={{ border: "1px solid #000", padding: "8px" }}>
                        {client?.denomination || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #000",
                          padding: "8px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        Mission
                      </th>
                      <td style={{ border: "1px solid #000", padding: "8px" }}>
                        {mission?.mission + " - " + mission?.annee || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #000",
                          padding: "8px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        Date d'édition
                      </th>
                      <td style={{ border: "1px solid #000", padding: "8px" }}>
                        {new Date().toLocaleDateString("fr-FR")} à{" "}
                        {new Date().toLocaleTimeString("fr-FR")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* ✅ Contenu principal avec numérotation - Collé directement */}
              <AcceptationPrint
                libelle="Critères à prendre en consideration relatifs à l'entité"
                dataEntite={selectedElementsListEntity}
                datasAuditeur={selectedElementsListAudit}
                associe_responsable={associe_responsable}
                second_associer={second_associer}
                mission={mission}
                client={client}
                observation_generale={observation_generale}
                mesure_sauve={mesure_sauve}
                showIndex={true} // ✅ Ajouter cette prop pour activer la numérotation
              />
            </div>

            {/* ✅ Section signatures si modalId === 2 */}
            {modalId === 2 && (
              <div
                className="section"
                style={{ pageBreakBefore: "auto", marginTop: "40px" }}
              >
                <h3
                  style={{
                    textAlign: "center",
                    fontSize: "14pt",
                    fontWeight: "bold",
                    marginBottom: "20px",
                    backgroundColor: "#f5f5f5",
                    padding: "10px",
                  }}
                >
                  DÉCISION ET AFFECTATION DU DOSSIER
                </h3>

                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #000",
                          padding: "8px",
                          backgroundColor: "#f5f5f5",
                          width: "50%",
                        }}
                      >
                        Associé Responsable
                      </th>
                      <th
                        style={{
                          border: "1px solid #000",
                          padding: "8px",
                          backgroundColor: "#f5f5f5",
                          width: "50%",
                        }}
                      >
                        Second Associé
                      </th>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #000",
                          padding: "20px",
                          height: "80px",
                          textAlign: "center",
                        }}
                      >
                        <div>
                          Nom: {associe_responsable || "_______________"}
                        </div>
                        <br />
                        <div>Signature:</div>
                        <br />
                        <div>Date: _______________</div>
                      </td>
                      <td
                        style={{
                          border: "1px solid #000",
                          padding: "20px",
                          height: "80px",
                          textAlign: "center",
                        }}
                      >
                        <div>Nom: {second_associer || "_______________"}</div>
                        <br />
                        <div>Signature:</div>
                        <br />
                        <div>Date: _______________</div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {observation_generale && (
                  <div style={{ marginTop: "20px" }}>
                    <h4
                      style={{
                        fontSize: "12pt",
                        fontWeight: "bold",
                      }}
                    >
                      Observations générales:
                    </h4>
                    <div
                      style={{
                        border: "1px solid #000",
                        padding: "10px",
                        minHeight: "60px",
                        backgroundColor: "#fafafa",
                      }}
                    >
                      {observation_generale}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {/* {isModalOpen && <IdentificationUser*/}
        {/* setDate={setDate}*/}
        {/* setTache_id={setTache_id}*/}
        {/* tache_id={tache_id}*/}
        {/* setIntervention_id={setIntervention_id}*/}
        {/* intervention_id={intervention_id}*/}
        {/* setUser_id={setUser_id}*/}
        {/* mission={mission}*/}
        {/* visible={isModalOpen}*/}
        {/* prev={prev}*/}
        {/* handleValider={handleModalOpen}*/}
        {/* setHeureEntree={setHeureEntree}*/}
        {/* loading={identLoading}*/}
        {/* /> */}
      </Fragment>
    </>
  );
};

export { AcceptationMission };
